import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, ModalFooter, ModalHeader } from 'reactstrap';
import auth from 'helpers/auth';
import BaseModal from 'components/shared/BaseModal';
import { TOKEN_ERROR } from 'redux-store/constants/action-types';


class MissingTokenModal extends Component {
  constructor(props) {
    super(props);
    this.handleModal = this.handleModal.bind(this);
  }

  handleModal() {
    const { hideModal: triggerModal } = this.props;
    triggerModal();
    auth.authenticate();
  }

  render() {
    const { tokenWarning } = this.props;
    return (
      <BaseModal
        handleModal={this.handleModal}
        modalOpen={tokenWarning}
        type="token"
      >
        <ModalHeader toggle={this.handleModal} />
        <div className="body">
          <div className="title-text font-weight-bold">
            Su sesión ha expirado
          </div>
          <div className="body-text">
            Por Favor, vuelva a iniciar sesión con sus credenciales
          </div>
        </div>
        <ModalFooter className="text-right">
          <Button className="token-accept" onClick={this.handleModal}>
            Aceptar
          </Button>
        </ModalFooter>
      </BaseModal>
    );
  }
}


MissingTokenModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  tokenWarning: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({ tokenWarning: state.login.tokenWarning });
const mapDispatchToProps = (dispatch) => ({
  hideModal: () => dispatch({ type: TOKEN_ERROR, payload: false })
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MissingTokenModal);
